var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"forgot-password-link"},[_c('router-link',{staticClass:"u-text-small u-text-dark-5 text-underline-offset",attrs:{"title":_vm.linkTitle,"to":_vm.urlLink}},[_vm._v("\n        "+_vm._s(_vm.linkTitle)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }